module.exports = __webpack_public_path__ + "static/Bell-Peppers-filled-with-feta-cheese-3f716de640ef0900f26411cb9aa041bc.png";